import React from 'react';
import HeaderNavbar from '../../containers/landingPage/HeaderNavbar'
import MainBannerBlue from '../../components/landingPage/Banners/BannerBlueGradient'
import Footer from '../../containers/landingPage/Footer'
import CareerForm from '../../containers/landingPage/CareerForm';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

function Careers() {
  const handleFormSubmit = async (userInfo) => {
    const { cv, name, email, phone_nb, message } = userInfo;
    
    var formData = new FormData();
    formData.append("cv", cv);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phoneNb", phone_nb);
    formData.append("message", message);
    return await axios.post(`${API_BASE_URL}/email/send-careers-email`, formData , { headers: {
      'Content-Type': 'multipart/form-data'
    }})
  }

  return (
    <div>
      {window.location.pathname === "/patient/careers" && (
        <HeaderNavbar dark aboutUs logo="white" patient />
      )}
      {window.location.pathname === "/professional/careers" && (
        <HeaderNavbar dark aboutUs logo="white" professional />
      )}
      <MainBannerBlue text="Careers at XiViX" />
      <CareerForm sendForm={handleFormSubmit} />
      <Footer />
    </div>
  );
}

export default Careers;
